/* eslint-disable tailwindcss/classnames-order */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import type { FC } from "react";
import {
  Avatar,
  Dropdown,
  DropdownDivider,
  DropdownHeader,
  DropdownItem,
  Navbar,
  NavbarBrand,
} from "flowbite-react";
import {
  HiLogout,
  HiMenuAlt1,
  HiSearch,
  HiViewGrid,
  HiX,
} from "react-icons/hi";
import { useSidebarContext } from "../context/SidebarContext";
import isSmallScreen from "../helpers/is-small-screen";
import cookie from "js-cookie";
import { useNavigate } from "react-router-dom";
import { fetchCurrentUser } from "../redux/actionCreators/auth";
import { currentUser } from "../services/user";
import { useDispatch } from "react-redux";
import AppLogo from "../assets/images/logo.png";
import { FaUserCircle } from "react-icons/fa";
import { isCancelReq } from "../util/axios";

const ThemeNavbar: FC = function () {
  const { isOpenOnSmallScreens, isPageWithSidebar, setOpenOnSmallScreens } =
    useSidebarContext();

  const [user, setUser]: any = useState({});

  const dispatch: any = useDispatch();

  const navigate = useNavigate();

  const token = cookie.get("token");

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }
    const init = async () => {
      try {
        await getCurrentUser();
      } catch (error) {
        if (!isCancelReq(error)) {
          console.log(error);
        }
      }
    };
    init();
  }, [navigate, token]);

  useEffect(() => {
    if (user && user.id) {
      dispatch(fetchCurrentUser());
    }
  }, [dispatch, user]);

  const getCurrentUser = async () => {
    let user: any = await currentUser();
    // updating current user in cookies

    user = user.data;

    cookie.set("name", user.user_name, { expires: 400 });
    cookie.set("email", user.user_email, { expires: 400 });
    cookie.set("user_profile_image", user.profile_image, { expires: 400 });

    setUser({
      ...user,
    });
  };

  return (
    <Navbar fluid>
      <div className="w-full p-3 lg:px-5 lg:pl-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            {isPageWithSidebar && (
              <button
                onClick={() => setOpenOnSmallScreens(!isOpenOnSmallScreens)}
                className="mr-3 cursor-pointer rounded-sm p-2 text-gray-600 hover:bg-gray-100 hover:text-gray-900 lg:inline dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              >
                <span className="sr-only">Toggle sidebar</span>
                {isOpenOnSmallScreens && isSmallScreen() ? (
                  <HiX className="size-6" />
                ) : (
                  <HiMenuAlt1 className="size-6" />
                )}
              </button>
            )}
            <NavbarBrand href="/">
              <img alt="" src={AppLogo} className="mr-3 h-6 sm:h-8" />
              <span className="self-center whitespace-nowrap text-2xl font-semibold dark:text-white"></span>
            </NavbarBrand>
          </div>
          <div className="flex items-center lg:gap-3">
            <div className="flex items-center">
              <button
                onClick={() => setOpenOnSmallScreens(!isOpenOnSmallScreens)}
                className="cursor-pointer rounded-sm p-2 text-gray-600 hover:bg-gray-100 hover:text-gray-900 focus:bg-gray-100 focus:ring-2 focus:ring-gray-100 lg:hidden dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white dark:focus:bg-gray-700 dark:focus:ring-gray-700"
              >
                <span className="sr-only">Search</span>
                <HiSearch className="size-6" />
              </button>
            </div>

            <UserDropdown />
          </div>
        </div>
      </div>
    </Navbar>
  );
};

const UserDropdown: FC = function () {
  const navigate = useNavigate();

  const [placeholder, setPlaceholder] = useState(false);

  const signOut = () => {
    cookie.remove("token");
    cookie.remove("admin");
    navigate("/");
    return;
  };

  return (
    <Dropdown
      arrowIcon={false}
      inline
      label={
        <span>
          <span className="sr-only">User menu</span>
          {placeholder ? (
            <FaUserCircle size={30} className="text-gray-400" />
          ) : (
            <Avatar
              alt=""
              img={(props) => (
                <img
                  src={cookie.get("user_profile_image")}
                  className={props.className}
                  alt={"User Avatar"}
                  onError={() => setPlaceholder(true)}
                />
              )}
              rounded
              size="sm"
            />
          )}
        </span>
      }
      className="overflow-hidden"
    >
      <DropdownHeader>
        <span className="block text-sm font-bold"> {cookie.get("name")}</span>
        <span className="block truncate text-sm">{cookie.get("email")}</span>
      </DropdownHeader>
      <DropdownItem icon={HiViewGrid} onClick={() => navigate("/")}>
        Dashboard
      </DropdownItem>
      <DropdownDivider />
      <DropdownItem onClick={signOut} icon={HiLogout}>
        Sign out
      </DropdownItem>
    </Dropdown>
  );
};

export default ThemeNavbar;
